module.exports = __webpack_public_path__ + "static/media/receipt_long.a65f2a62.svg";